import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../../Icon';

export default function ActionButton(props) {
    const handleClick = (e) => {
        e.stopPropagation();
        props.disabled || props.action();
    };

    return (
        <button
            type="button"
            className={`sg-button-action appActions-button ${props.disabled ? 'sg-disabled' : ''}`}
            data-tooltip={props.disabled ? props.disabledTooltip : null}
            onClick={handleClick}
        >
            <Icon alias={props.alias} />
            {props.text ? <span>{props.text}</span> : ''}
        </button>
    );
}

ActionButton.propTypes = {
    alias: PropTypes.string.isRequired,
    disabledTooltip: PropTypes.string.isRequired,
    // action is required when disabled is falsy
    action: PropTypes.func,
    text: PropTypes.string,
    disabled: PropTypes.bool,
};
